<template>
  <svg
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6858 4.64742C11.7794 4.74117 11.832 4.86825 11.832 5.00075C11.832 5.13325 11.7794 5.26034 11.6858 5.35409L7.6858 9.35409C7.64003 9.40321 7.58483 9.44261 7.5235 9.46994C7.46216 9.49727 7.39595 9.51196 7.32882 9.51315C7.26168 9.51433 7.195 9.50198 7.13274 9.47683C7.07048 9.45169 7.01393 9.41426 6.96645 9.36678C6.91897 9.3193 6.88154 9.26274 6.85639 9.20048C6.83124 9.13823 6.81889 9.07154 6.82008 9.00441C6.82126 8.93727 6.83596 8.87106 6.86328 8.80973C6.89061 8.74839 6.93001 8.69319 6.97914 8.64742L10.1258 5.50075L0.665805 5.50075C0.533197 5.50075 0.406019 5.44807 0.312251 5.35431C0.218483 5.26054 0.165805 5.13336 0.165805 5.00075C0.165805 4.86814 0.218483 4.74097 0.312251 4.6472C0.406019 4.55343 0.533197 4.50075 0.665805 4.50075L10.1258 4.50075L6.97914 1.35409C6.93001 1.30831 6.89061 1.25311 6.86328 1.19178C6.83596 1.13045 6.82126 1.06424 6.82008 0.997102C6.81889 0.929966 6.83124 0.86328 6.85639 0.801021C6.88154 0.738763 6.91897 0.682207 6.96645 0.634728C7.01393 0.587249 7.07048 0.549819 7.13274 0.524671C7.195 0.499524 7.26168 0.487175 7.32882 0.488359C7.39595 0.489544 7.46216 0.504238 7.5235 0.531566C7.58483 0.558894 7.64003 0.598295 7.6858 0.64742L11.6858 4.64742Z"
      fill="black"
    />
  </svg>
</template>

<script>
export default {
  name: "ArrowRightColored",
};
</script>
